/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Input tokens of a token usage object. Older logs store them as promptTokenCount.
 * Includes cached reads and cache writes.
 * @param {Object} usage
 * @returns {number}
 */
export const getInputTokens = (usage = {}) =>
  Number(usage?.inputTokenCount ?? usage?.promptTokenCount) || 0;

/**
 * Total tokens of a token usage object. Output already includes reasoning tokens,
 * so the total is input + output when the log does not carry totalTokenCount.
 * @param {Object} usage
 * @returns {number}
 */
export const getTotalTokens = (usage = {}) =>
  Number(usage?.totalTokenCount) || getInputTokens(usage) + (Number(usage?.outputTokenCount) || 0);

/**
 * Input tokens billed at the plain input rate (excludes cache reads and cache writes).
 * @param {Object} usage
 * @returns {number}
 */
export const getPlainInputTokens = (usage = {}) =>
  Math.max(
    getInputTokens(usage) -
      (Number(usage?.cachedTokenCount) || 0) -
      (Number(usage?.cacheWriteTokenCount) || 0),
    0
  );
